/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Phosphorus List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PhosphorusListView';

export const mapStateToPropsPhosphorusList = mapStateToProps;
export const mapDispatchToPropsPhosphorusList = mapDispatchToProps;

export default connect(
  mapStateToPropsPhosphorusList,
  mapDispatchToPropsPhosphorusList
)(View);
